import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Edit from '@mui/icons-material/Edit';
import Save from '@mui/icons-material/Save';
import Cancel from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import AccountsApi from '../../api/accounts';
import Formatter, { printFilingStatus } from '../../utils/Formatter';
import Validators from '../../utils/Validators';
import AnalysisTools from '../../utils/AnalysisTools';
import UserSurvey from '../UserSurvey';
import DomainsApi from '../../api/domains';
import MSDUserInfo from './MSDUserInfo';
import MSDDetails from './MSDDetails';
import EmploymentInfo from './EmploymentInfo';
import AdministratorsApi from '../../api/administrators';
import { CensusFileStatus } from './CensusFileStatus';
import { Switch } from '@mui/material';

class UserInfo extends Component {
  state = {
    currentTab: 0,
    domains: [],
    edit_personal_info: false,
    edit_billing_info: false,
    personal_info: {
      firstname: this.props.account.firstname,
      lastname: this.props.account.lastname,
      middlename: this.props.account.middlename,
      domain: this.props.account.domain,
      email: this.props.account.email,
      secondary_email: this.props.account.secondary_email,
      phone: this.props.account.phone,
      dob: this.props.account.dob,
      alias: this.props.account.alias,
      accountManager: this.props.account.accountManager,
      code: this.props.account.code,
      address: {
        address1: this.props.account.address
          ? this.props.account.address.address1
          : '',
        address2: this.props.account.address
          ? this.props.account.address.address2
          : '',
        city: this.props.account.address ? this.props.account.address.city : '',
        state: this.props.account.address
          ? this.props.account.address.state
          : '',
        zip: this.props.account.address ? this.props.account.address.zip : ''
      },
      employerKey: this.props.account.employerKey,
      is2FAEnabled: this.props.account.is2FAEnabled
    },
    edit_financial_info: false,
    financial_info: {
      agi: this.props.account.finances ? this.props.account.finances.agi : '',
      status: this.props.account.finances
        ? this.props.account.finances.status
        : '',
      dependants: this.props.account.finances
        ? this.props.account.finances.dependants
        : '',
      roommates_number: this.props.account.finances
        ? this.props.account.finances.roommates_number
        : '',
      spouse: this.props.account.finances
        ? this.props.account.finances.spouse
        : '',
      spouse_debt: this.props.account.finances
        ? this.props.account.finances.spouse_debt
        : false,
    },
    busy: true,
    last_update_by: 'peoplejoy',
    admins: [],
    accountManagers: [],
  };
  async componentDidMount() {
    window.scrollTo(0, 0);
    // referral needs a rethink
    // AccountsApi.get(this.props.account.profile.referredBy)
    // this.setState({
    //   hasReferral: true,
    //   referralAccount: account
    // });
    const domainPromise = DomainsApi.all();
    const administratorPromise = AdministratorsApi.getList();
    const data = await Promise.all([domainPromise, administratorPromise])
    this.setState({
      domains: data[0],
      admins: data[1],
      accountManagers: data[1].filter(admin => admin.accountManager),
      busy: false
    })

  }
  interest = () => {
    let interest = AnalysisTools.getWeightedInterestRate(this.props.account);
    if (interest === 0) return 'Unknown';
    else return `${interest}%`;
  };
  updateBillingEmail = () => {
    AccountsApi.updateBillingEmail(
      this.props.account.customer,
      this.state.billing_email
    )
      .then(customer => {
        this.props.showMessage('Billing email updated successfully!');
        this.setState({
          edit_billing_info: false,
          busy: false,
          stripe_email: customer.customer.email,
          billing_email: customer.customer.email
        });
      })
      .catch(error =>
        this.setState({ busy: false }, () =>
          this.props.showError(
            'Error occurred while attempting to update the billing email, please try again.'
          )
        )
      );
  };

  validateUserInput = () => {
    if (this.state.personal_info.address.address1.length < 5) {
      return this.props.showError('Please enter your address.');
    }
    if ((this.state.personal_info.address.city || "").length < 3) {
      return this.props.showError('Please enter your city.');
    }
    if (!this.state.personal_info.address.state) {
      return this.props.showError('Please select your state');
    }
    if ((this.state.personal_info.address.zip || "").length < 5) {
      return this.props.showError('Please enter your Zip Code');
    }
  }
  updatePersonalInfo = async () => {
    if (!this.state.personal_info.domain) {
      return this.props.showError('Please indicate the referring company.');
    }
    if (!this.state.personal_info.firstname) {
      return this.props.showError('The user First name is required');
    }
    if (!this.state.personal_info.lastname) {
      return this.props.showError('The user Last name is required');
    }
    if (!Validators.isValidEmail(this.state.personal_info.email)) {
      return this.props.showError('A valid email address is required');
    }
    if (
      this.state.personal_info.phone &&
      !Validators.isValidPhone(this.state.personal_info.phone)
    ) {
      return this.props.showError('A valid phone number is required');
    }

    this.props.account.membership === 1 && this.validateUserInput()

    const selectedActMgr = this.state.accountManagers.find(each => each._id === this.state.personal_info.accountManager);
    const isAssignedDomain = (selectedActMgr?.domains || []).includes(this.props.account?.domain);
    if (!isAssignedDomain && this.props.account.membership === 1) {
      this.props.confirmAction("You are about to reassign users to an admin who is not assigned to any of the checked user's domain(s). Do you wish to proceed?",
        this.onUpdatePersonalInfo, "New Account Manager", "Continue", "No", () => { }
      )
    } else {
      this.onUpdatePersonalInfo()
    }
  };

  onUpdatePersonalInfo = async (isDisabling2fa) => {
    this.setState({ busy: true });
    try {
      await AccountsApi.updatePersonalInfo(
        this.props.id,
        this.state.personal_info.firstname,
        this.state.personal_info.lastname,
        this.state.personal_info.dob || '',
        this.state.personal_info.email,
        (this.state.personal_info.phone ?? '').replace(/[^0-9]/g, ''),
        this.state.personal_info.address,
        this.state.personal_info.domain,
        this.state.personal_info.middlename,
        this.state.personal_info.accountManager,
        this.state.personal_info.alias,
        this.state.last_update_by,
        this.state.personal_info.secondary_email,
        this.state.personal_info.code,
        this.state.personal_info.employerKey,
        isDisabling2fa ? false : this.state.personal_info.is2FAEnabled
      );
      this.props.onPersonalInfoUpdated({
        ...this.state.personal_info,
        phone: (this.state.personal_info.phone ?? '').replace(/[^0-9]/g, ''),
        is2FAEnabled: isDisabling2fa ? false : this.state.personal_info.is2FAEnabled,
        employer: this.state.domains.find(domain => domain._id === this.state.personal_info.domain)
      });
      this.props.showMessage('Personal information updated successfully!');
      this.setState({ edit_personal_info: false });
    } catch (error) {
      this.props.showError(error.response.data.message || 'There has been an error updating the personal information, make sure there is not another user registered with the same email address and try again.')
    } finally {
      this.setState({ busy: false });
    }
  }

  onToggle2FA = async (e) => {
    this.props.confirmAction("You are about to disable this user's 2FA. Do you wish to proceed?",
      () => {
        this.onUpdatePersonalInfo(true)
        this.setState({
          personal_info: { ...this.state.personal_info, is2FAEnabled: false }
        })
      }, "Disable 2FA", "Continue", "No", () => { }
    )
  }

  runAnalysis = async () => {
    try {
      const analysis = await AccountsApi.runAnalysis(this.props.id);
      let message;
      if (analysis.locked) {
        message = "User has a locked analysis, please visit the strategy tab to review the live strategy for chanegs which is based on user's current data on the strategy's page"
      } else if (analysis.approved) {
        message = "New analysis generated and it's already approved, this means there was no major change between the old and new analysis"
      } else {
        message = "New analysis generated, please visit the strategy tab to edit or approve it"
      }
      this.props.showMessage(message);
      this.props.onAnalysisUpdated(analysis, this.props.account.forms);
    } catch (error) {
      if (error.response.data.message) {
        return this.props.showError(error.response.data.message)
      }
      this.props.showError();
    } finally {
      this.setState({
        edit_financial_info: false,
        edit_employment_info: false,
        busy: false
      });
    }
  }
  updateFinancialInfo = () => {
    if (
      !Validators.isWholeNumber(this.state.financial_info.agi) ||
      !this.state.financial_info.status
    ) {
      this.props.showError('All fields are required');
    } else {

      const payload = {
        agi: Number(this.state.financial_info.agi),
        status: this.state.financial_info.status,
        dependants: this.state.financial_info.dependants || 0,
        roommates: this.state.financial_info.roommates_number || 0,
        spouse: this.state.financial_info.spouse || 0,
        spouse_debt: this.state.financial_info.spouse_debt,
        last_update_by: this.state.last_update_by
      }
      this.setState({ busy: true }, () =>
        AccountsApi.updateFinancialInfo(
          this.props.id, payload)
          .then(
            success => {
              this.props.onFinancialInfoUpdated({
                ...this.state.financial_info,
                updated: moment().format('X')
              });
              this.props.showMessage(
                'Financial information updated successfully!'
              );
              this.props.confirmAction(
                'The new financial information might impact the strategy found for this user. Would you like to run the analysis again with the new financial information?',
                this.runAnalysis,
                'Update Analysis',
                'Run Analysis',
                "Don't Run it",
                () => this.setState({ edit_financial_info: false, busy: false })
              );
            },
            error => this.setState({ busy: false }, this.props.showError)
          )
          .catch(error => this.setState({ busy: false }, this.props.showError))
      );
    }

  };
  updateEmploymentInfo = employmentInfo => {
    this.props.onEmploymentInfoUpdated({
      ...employmentInfo,
      updated: moment().format('X')
    });
    this.props.showMessage('Employment information updated successfully!');
    this.props.confirmAction(
      'The new employment information might impact the strategy found for this user. Would you like to run the analysis again with the new employment information?',
      this.runAnalysis,
      'Update Analysis',
      'Run Analysis',
      "Don't Run it",
      () => this.setState({ edit_employment_info: false, busy: false })
    );
  };

  accountManagerOptions = () => {
    const options = this.state.accountManagers;
    if (!options.find(eachManager => eachManager._id === this.state.personal_info.accountManager)) {
      // that means this client's manager is no longer an account manager, we still want to show the manager though so that
      // crm admins won't mistakenly reassign the user
      const theAdmin = this.state.admins.find(manager => manager._id === this.state.personal_info.accountManager);
      if (theAdmin) {
        options.push(theAdmin)
      }
    }
    return options;
  }
  download = () => {
    AccountsApi.download(this.props.account.msd.file)
      .then(
        success => { },
        error => this.props.showError()
      )
      .catch(error => this.props.showError());
  };

  getIDRDate = () => {
    if (this.props.account.idr_recertification) {
      const date = moment.unix(this.props.account.idr_recertification.date);
      return date.format('MM/DD/YYYY');
    }
    return "N/A"
  }
  renderPersonalInformationForm = () => {
    const myStudentData = this.props.account.msd || {};
    return (
      <Paper>
        <div className="full-width padding">
          <div className="action-buttons">
            {this.state.edit_personal_info && this.state.busy && (
              <div style={{ padding: '10px' }}>
                <CircularProgress size={24} />
              </div>
            )}
            {!this.state.edit_personal_info && (
              <Tooltip title="Edit">
                <IconButton
                  onClick={() =>
                    this.setState({
                      edit_personal_info: true,
                      edit_financial_info: false,
                      personal_info: {
                        firstname: this.props.account.firstname,
                        middlename: this.props.account.middlename,
                        domain: this.props.account.domain,
                        lastname: this.props.account.lastname,
                        email: this.props.account.email,
                        secondary_email: this.props.account.secondary_email,
                        phone: this.props.account.phone,
                        dob: this.props.account.dob,
                        alias: this.props.account.alias,
                        code: this.props.account.code,
                        accountManager: this.props.account.accountManager,
                        address: {
                          address1: this.props.account.address
                            ? this.props.account.address.address1
                            : '',
                          address2: this.props.account.address
                            ? this.props.account.address.address2
                            : '',
                          city: this.props.account.address
                            ? this.props.account.address.city
                            : '',
                          state: this.props.account.address
                            ? this.props.account.address.state
                            : '',
                          zip: this.props.account.address
                            ? this.props.account.address.zip
                            : ''
                        },
                        employerKey: this.props.account.employerKey,
                        is2FAEnabled: this.props.account.is2FAEnabled
                      }
                    })
                  }
                >
                  <Edit />
                </IconButton>
              </Tooltip>
            )}
            {this.state.edit_personal_info && !this.state.busy && (
              <Tooltip title="Save Changes">
                <IconButton onClick={this.updatePersonalInfo}>
                  <Save />
                </IconButton>
              </Tooltip>
            )}
            {this.state.edit_personal_info && !this.state.busy && (
              <Tooltip title="Cancel Changes">
                <IconButton
                  onClick={() => this.setState({ edit_personal_info: false })}
                >
                  <Cancel />
                </IconButton>
              </Tooltip>
            )}
          </div>
          Personal Information{' '}
          {AnalysisTools.hasRecertificationPending(this.props.account) &&
            (!this.props.account.confirmations.personal_info ||
              this.props.account.confirmations.personal_info <
              AnalysisTools.getRecertificationThreshold()) && (
              <div className="indicator-badge">update required</div>
            )}
          <div className="indicator-badge-gray">
            {(this.props.account.confirmations &&
              this.props.account.confirmations.personal_last_update_by ===
              'peoplejoy') ||
              this.props.account.personal_info_last_update_by === 'peoplejoy'
              ? 'PeopleJoy '
              : 'User '}
            last confirmed Personal Information on{' '}
            {moment(
              (this.props.account.confirmations &&
                this.props.account.confirmations.personal_info),
              'X'
            ).format('MM/DD/YYYY')}
          </div>
          <div className="line-break" />
          <div className="row">
            <div className="col-3">
              {!this.state.edit_personal_info && (
                <div className="info-block">
                  <label>Account Manager</label>
                  {(this.state.personal_info.accountManager &&
                    (this.state.admins.find(m => m._id === this.state.personal_info.accountManager) || {}).name) ||
                    'No one assigned'}
                </div>
              )}
              {this.state.edit_personal_info && (
                <div className="info-block">
                  <FormControl className="full-width font-normal">
                    <InputLabel htmlFor="domain">Account Manager</InputLabel>
                    <Select
                      value={this.state.personal_info.accountManager}
                      onChange={e =>
                        this.setState({
                          personal_info: {
                            ...this.state.personal_info,
                            accountManager: e.target.value
                          }
                        })
                      }
                      inputProps={{
                        name: 'accountManager',
                        id: 'accountManager'
                      }}
                    >
                      <MenuItem value="">Select...</MenuItem>
                      {(this.accountManagerOptions()).map((manager, index) => (
                        <MenuItem key={`manager-${index}`} value={manager._id}>
                          {manager.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}
            </div>
            {!this.state.edit_personal_info && this.state.hasReferral && (
              <div className="col-3">
                <div className="info-block">
                  <label>Referred By</label>
                  {this.state.referralAccount.name || 'PeopleJoy'}{' '}
                </div>
              </div>
            )}
            <div className="col-3">
              {!this.state.edit_personal_info && (
                <div className="info-block">
                  <label>Referring Company</label>
                  {this.props.account.employer.name}{' '}
                </div>
              )}
              {this.state.edit_personal_info && (
                <div className="info-block">
                  <FormControl className="full-width font-normal">
                    <InputLabel htmlFor="domain">Referring Company</InputLabel>
                    <Select
                      value={this.state.personal_info.domain || ''}
                      onChange={e =>
                        this.setState({
                          personal_info: {
                            ...this.state.personal_info,
                            domain: e.target.value
                          }
                        })
                      }
                      inputProps={{
                        name: 'domain',
                        id: 'domain'
                      }}
                    >
                      <MenuItem value="">Select...</MenuItem>
                      {this.state.domains.map((domain, index) => (
                        <MenuItem key={`domain-${index}`} value={domain._id}>
                          {domain.company}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info &&
                  (<div>
                    <label>Auth Code</label>
                    {this.props.account.code || '-'}
                  </div>)
                }
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    id="code"
                    label="Auth Code"
                    value={this.state.personal_info.code || ''}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          code: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Alias</label>
                    {this.props.account.alias || 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    id="alias"
                    label="Alias"
                    value={this.state.personal_info.alias}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          alias: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Firstname</label>
                    {this.props.account.firstname || 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    id="firstname"
                    label="Firstname"
                    value={this.state.personal_info.firstname}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          firstname: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Middle Name</label>
                    {this.props.account.middlename || 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    id="middlename"
                    label="Middle Name"
                    value={this.state.personal_info.middlename}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          middlename: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Lastname</label>
                    {this.props.account.lastname || 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    id="lastname"
                    label="Lastname"
                    value={this.state.personal_info.lastname}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          lastname: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Date of Birth</label>
                    {Formatter.toStandardDate(this.props.account.dob) ||
                      'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="date"
                    id="dob"
                    label="Date of birth"
                    value={this.state.personal_info.dob}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          dob: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Email Address</label>
                    {this.props.account.email ? (
                      <a href={`mailto:${this.props.account.email}`}>
                        {this.props.account.email.toLowerCase()}
                      </a>
                    ) : (
                      'Unknown'
                    )}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="email"
                    id="email"
                    label="Email Address"
                    value={this.state.personal_info.email}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          email: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Secondary Email Address</label>
                    {this.props.account.secondary_email ? (
                      <a href={`mailto:${this.props.account.secondary_email}`}>
                        {this.props.account.secondary_email.toLowerCase()}
                      </a>
                    ) : (
                      'Unknown'
                    )}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="email"
                    id="email"
                    label="Secondary Email Address"
                    value={this.state.personal_info.secondary_email}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          secondary_email: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Phone Number</label>
                    {this.props.account.phone ? (
                      <a target='_blank' rel="noreferrer" href={`https://voice.google.com/u/0/messages?itemId=t.%2B1${this.props.account.phone.replace(/\D/g, '')}`}>
                        {this.props.account.phone}
                      </a>
                    ) : (
                      'Unknown'
                    )}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="tel"
                    id="phone"
                    label="Phone Number"
                    value={this.state.personal_info.phone}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          phone: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Address Line 1</label>
                    {this.props.account.address &&
                      this.props.account.address.address1
                      ? this.props.account.address.address1
                      : 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="text"
                    id="address1"
                    label="Address Line 1"
                    value={this.state.personal_info.address.address1}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          address: {
                            ...this.state.personal_info.address,
                            address1: e.target.value
                          }
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Address Line 2</label>
                    {this.props.account.address &&
                      this.props.account.address.address2
                      ? this.props.account.address.address2
                      : 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="text"
                    id="address2"
                    label="Address Line 2"
                    value={
                      this.state.personal_info.address
                        ? this.state.personal_info.address.address2
                        : ''
                    }
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          address: {
                            ...this.state.personal_info.address,
                            address2: e.target.value
                          }
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>City</label>
                    {this.props.account.address &&
                      this.props.account.address.city
                      ? this.props.account.address.city
                      : 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="text"
                    id="city"
                    label="City"
                    value={this.state.personal_info.address.city}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          address: {
                            ...this.state.personal_info.address,
                            city: e.target.value
                          }
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>State</label>
                    {this.props.account.address &&
                      this.props.account.address.state
                      ? this.props.account.address.state
                      : 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <select
                    name="state"
                    className="form-control full-width"
                    value={this.state.personal_info.address.state}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          address: {
                            ...this.state.personal_info.address,
                            state: e.target.value
                          }
                        }
                      })
                    }
                  >
                    <option value="">--Select state--</option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                    <option value="PR">Puerto Rico</option>
                  </select>
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Zip Code</label>
                    {this.props.account.address &&
                      this.props.account.address.zip
                      ? this.props.account.address.zip
                      : 'Unknown'}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="text"
                    id="zip"
                    label="Zip Code"
                    value={this.state.personal_info.address.zip}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          address: {
                            ...this.state.personal_info.address,
                            zip: e.target.value
                          }
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_personal_info && (
                  <div>
                    <label>Employer ID</label>
                    {this.props.account.employerKey || "Unknown"}
                  </div>
                )}
                {this.state.edit_personal_info && (
                  <TextField
                    disabled={this.state.busy}
                    id="employerKey"
                    label="Employer ID"
                    value={this.state.personal_info.employerKey}
                    onChange={e =>
                      this.setState({
                        personal_info: {
                          ...this.state.personal_info,
                          employerKey: e.target.value
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                <div>
                  <label>Days since last touchbase</label>
                  {
                    this.props.account.lastTouchBase
                      ? `${Formatter.getNoOfDays(this.props.account.lastTouchBase)} day(s) ago on ${moment(this.props.account.lastTouchBase).format('MM/DD/YYYY')}`
                      : "No touchbase yet"
                  }
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                <div>
                  <label>IDR Anniversary Date</label>
                  {this.getIDRDate()}
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                <div>
                  <label>User Last Login Date/Time</label>
                  {moment(new Date(this.props.account.lastLoginAt)).format("MM/DD/YYYY h:mm A")}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {!this.props.account.hasSso && <div className="col-3">
              <div className="info-block">
                <label>Two factor Authentication</label>
                <Switch
                  disabled={!this.state.personal_info.is2FAEnabled || this.state.edit_personal_info}
                  checked={this.state.personal_info.is2FAEnabled}
                  onChange={this.onToggle2FA} />
              </div>
            </div>}
            <div className="col-3">
              <div className="info-block">
                <label>Program ID</label>
                {this.props.account.programAuthCode || 'N/A'}
              </div>
            </div>

            <div className="col-3">
              <div className="info-block">
                <label>SSO Enabled</label>
                {this.props.account.hasSso ? 'YES' : "NO"}
              </div>
            </div>
          </div>
          {this.props.account.loanType === 'private' && ("privateLoanInfo" in this.props.account) && (
            <div>
              <br></br>
              <br></br>
              <div className="row">
                <div className="col-3">
                  <div className="info-block">
                    <div>
                      <label>Private Loan Interest</label>
                      {this.props.account.privateLoanInfo.interestRate}%
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="info-block">
                    <div>
                      <label>Private Loan Balance</label>
                      {this.props.account.privateLoanInfo.balance}
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="info-block">
                    <div>
                      <label>Private Loan Monthly Payment</label>
                      {this.props.account.privateLoanInfo.monthlyPayment}
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="info-block">
                    <div>
                      <label>Private Loan Servicer</label>
                      {this.props.account.privateLoanInfo.loanServicer}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-3">
                  <div className="info-block">
                    <div>
                      <label>Private Loan Option</label>
                      {this.props.account.privateLoanInfo.loanOption}
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="info-block">
                    <div>
                      <label>Private Loan Payment Option</label>
                      {this.props.account.privateLoanInfo.paymentOption}
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="info-block">
                    <div>
                      <label>Private Loan Refinancing?</label>
                      {this.props.account.privateLoanInfo.refinancingLoan}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <br></br>
          <br></br>
          <br></br>
          <MSDUserInfo
            isEditing={this.state.edit_personal_info}
            myStudentData={myStudentData.details || {}}
          />
        </div>
      </Paper>
    );
  };
  renderBillingInformationForm = () => {
    return (
      <Paper>
        <div className="full-width padding">
          <div className="action-buttons">
            {this.state.edit_billing_info && this.state.busy && (
              <div style={{ padding: '10px' }}>
                <CircularProgress size={24} />
              </div>
            )}
            {!this.state.edit_billing_info && (
              <Tooltip title="Edit">
                <IconButton
                  onClick={() =>
                    this.setState({
                      edit_billing_info: true,
                      billing_email: this.state.stripe_email
                    })
                  }
                >
                  <Edit />
                </IconButton>
              </Tooltip>
            )}
            {this.state.edit_billing_info && !this.state.busy && (
              <Tooltip title="Save Changes">
                <IconButton onClick={this.updateBillingEmail}>
                  <Save />
                </IconButton>
              </Tooltip>
            )}
            {this.state.edit_billing_info && !this.state.busy && (
              <Tooltip title="Cancel Changes">
                <IconButton
                  onClick={() => this.setState({ edit_billing_info: false })}
                >
                  <Cancel />
                </IconButton>
              </Tooltip>
            )}
          </div>
          Billing Information <br></br>
          <br></br>
          <div className="row">
            <div className="col-12 text-center">
              {this.state.edit_billing_info && (
                <>
                  <div className="col-3">
                    <TextField
                      disabled={this.state.busy}
                      type="text"
                      id="billingEmail"
                      label="Billing Email"
                      value={
                        this.state.billing_email ? this.state.billing_email : ''
                      }
                      onChange={e =>
                        this.setState({
                          billing_email: e.target.value
                        })
                      }
                      className="font-normal full-width"
                    />
                  </div>
                  <div>
                    <p>
                      <small>
                        You can only edit the billing email to edit other fields
                        reach out to the tech team at tech@peoplejoy.co
                      </small>
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_billing_info && (
                  <div>
                    <label>Name on Card</label>
                    {this.state.stripe_name
                      ? this.state.stripe_name
                      : 'Unknown'}
                  </div>
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_billing_info && (
                  <div>
                    <label>Last 4 Digits</label>
                    {this.state.stripe_last4
                      ? this.state.stripe_last4
                      : 'Unknown'}
                  </div>
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_billing_info && (
                  <div>
                    <label>Expiry Date</label>
                    {this.state.stripe_expiry_month
                      ? this.state.stripe_expiry_month
                      : 'Unknown'}
                    /
                    {this.state.stripe_expiry_year
                      ? this.state.stripe_expiry_year
                      : 'Unknown'}
                  </div>
                )}
              </div>
            </div>
            <div className="col-3">
              <div className="info-block">
                {!this.state.edit_billing_info && (
                  <div>
                    <label>
                      Billing Email{' '}
                      <small>
                        Email where billing information will be sent
                      </small>
                    </label>
                    {this.state.stripe_email
                      ? this.state.stripe_email
                      : 'Unknown'}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Paper>
    );
  };
  getMembershipStartDate = () => {
    if (this.props.account.subscription_date && this.props.account.date) {
      return moment(
        Math.max(this.props.account.subscription_date, this.props.account.date),
        'X'
      ).format('MM/DD/YYYY');
    } else if (this.props.account.subscription_date) {
      return moment(this.props.account.subscription_date, 'X').format(
        'MM/DD/YYYY'
      );
    } else if (this.props.account.date) {
      return moment(this.props.account.date, 'X').format('MM/DD/YYYY');
    } else {
      return '-';
    }
  };

  getStrategyStatus = () => {
    if (this.props.account.status === 'lost') {
      return 'not-approved'
    }
    if ((this.props.account.msd && this.props.account.msd.details || {}).isArtificial) {
      return 'pending'
    }
    if (this.props.account.analysis && !this.props.account.analysis.approved) {
      return 'Awaiting Review'
    }
    if (this.props.account.analysis && this.props.account.analysis.approved) {
      return 'approved'
    }
  }

  getActivationType = () => {
    const { subscription } = this.props.account;
    if (subscription === 'manual' || subscription === 'automatic') {
      return `(${subscription} activation)`
    }
    return '';
  }

  renderAccountInformation = () => {
    return (
      <div className="col-4">
        <Paper>
          <div className="full-width padding">
            Account Information
            <div className="line-break" />
            <div className="full-width row">
              <div className="info-block col-sm-12 col-md-6">
                <label>First Visit Date</label>
                {moment(this.props.account.date, 'X').format('MM/DD/YYYY')}
              </div>
              <div className="info-block col-sm-12 col-md-6">
                <label>Subscription Status</label>
                {this.state.sub_status ? this.state.sub_status : 'Unknown'}
              </div>
              <div className="info-block col-sm-12 col-md-6">
                <label>Membership Tier</label>
                {this.props.account.membership > 0
                  ? this.props.account.membership == 1
                    ? 'Platinum'
                    : 'Gold'
                  : 'None'}
              </div>
              <div className="info-block col-sm-12 col-md-6">
                <label>Subscription Current Period Start</label>
                {this.state.current_period_start
                  ? this.state.current_period_start
                  : 'Unknown'}
              </div>
              <div className="info-block col-sm-12 col-md-6">
                <label>Membership Status</label>
                {this.props.account.membership > 0 ? (
                  `Active ${this.getActivationType()}`
                ) : this.props.account.membership == -1 ? (
                  <span style={{ color: 'red' }}>Canceled</span>
                ) : (
                  "'Inactive'"
                )}
              </div>
              <div className="info-block col-sm-12 col-md-6">
                <label>Subscription Current Period End</label>
                {this.state.current_period_end
                  ? this.state.current_period_end
                  : 'Unknown'}
              </div>
              {this.props.account.membership > 0 && (
                <div className="info-block col-sm-12 col-md-6">
                  <label>Membership Start Date</label>
                  {this.getMembershipStartDate()}
                </div>
              )}
              <div className="info-block col-sm-12 col-md-6">
                <label>Strategy</label>
                {AnalysisTools.hasRecertificationPending(this.props.account) &&
                  (!this.props.account.analysis.updated ||
                    this.props.account.analysis.updated <
                    AnalysisTools.getRecertificationThreshold()) ? (
                  <div className="indicator-badge">review required</div>
                ) : (
                  <span className={`small-badge ${this.getStrategyStatus()}`}>
                    {this.getStrategyStatus()}
                  </span>
                )}
              </div>
            </div>
          </div>
        </Paper>
      </div>
    );
  };

  render() {
    const myStudentData = this.props.account.msd || {};
    const grossIncomeText = this.state.financial_info.status === "married-jointly" ? "Joint Gross Income" : "Individual Gross Income"
    return (
      <div>
        <div className="padding">
          <div className='row'>
            <div className='col-6 d-flex align-items-center'>
              <h4>Summary</h4>
            </div>
            <div className='col-6 d-flex justify-content-end align-items-center h-100 mb-2'>
              <CensusFileStatus censusData={this.props.account.censusMatchData} />
            </div>

          </div>

          <div className="row">
            <div className="col-12">
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Total Outstanding Balance</TableCell>
                      {/* <TableCell>Current Repayment Plan</TableCell> */}
                      <TableCell>Current MMP</TableCell>
                      {/* <TableCell>Recommended Plan</TableCell> */}
                      <TableCell>MMP With Recommended Plan</TableCell>
                      <TableCell>Forgiveness Found</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      className="clickable"
                      onClick={this.props.onAnalysis}
                    >
                      <TableCell>
                        {myStudentData.details &&
                          myStudentData.details.student_loans.length > 0
                          ? `$${Formatter.money(
                            AnalysisTools.getCurrentBalance(
                              this.props.account
                            )
                          )}`
                          : 'Unknown'}
                      </TableCell>
                      {/* <TableCell><span className="pre-wrap">{ AnalysisTools.getCurrentPlan(this.props.account) }</span></TableCell> */}
                      <TableCell>
                        {myStudentData.details
                          ? `$${Formatter.money(
                            AnalysisTools.getCurrentMMP(this.props.account)
                          )}`
                          : 'Unknown'}
                      </TableCell>
                      <TableCell>
                        {this.props.account.analysis
                          ? `$${Formatter.money(
                            this.props.account.hasOwnProperty("loanType") && this.props.account.loanType === "private" ? 0 : this.props.account.analysisPreview.mmp
                          )}`
                          : '-'}
                      </TableCell>
                      <TableCell>{`$${Formatter.money(this.props.account.analysisPreview.forgiveness)}`}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            </div>
          </div>
        </div>
        <div className="line-break" />
        <div className="padding">
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <h4>User Information</h4>
          </div>
          <div className="row animated fadeIn">
            <div className="col-12" style={{ marginBottom: '20px' }}>
              {this.renderPersonalInformationForm()}
            </div>
            <div className="col-4" style={{ marginBottom: '20px' }}>
              <Paper>
                <div className="full-width padding">

                  <div className="action-buttons">
                    {this.state.edit_financial_info && this.state.busy && (
                      <div style={{ padding: '10px' }}>
                        <CircularProgress size={24} />
                      </div>
                    )}
                    {!this.state.edit_financial_info && (
                      <Tooltip title="Edit">
                        <IconButton
                          onClick={() =>
                            this.setState({
                              edit_financial_info: true,
                              edit_personal_info: false,
                              financial_info: {
                                agi: this.props.account.finances
                                  ? this.props.account.finances.agi
                                  : '',
                                status: this.props.account.finances
                                  ? this.props.account.finances.status
                                  : '',
                                dependants: this.props.account.finances
                                  ? this.props.account.finances.dependants
                                  : '',
                                roommates_number: this.props.account.finances
                                  ? this.props.account.finances.roommates_number
                                  : '',
                                spouse: this.props.account.finances
                                  ? this.props.account.finances.spouse
                                  : '',
                                spouse_debt: this.props.account.finances
                                  ? this.props.account.finances.spouse_debt
                                  : false,
                              }
                            })
                          }
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                    )}
                    {this.state.edit_financial_info && !this.state.busy && (
                      <Tooltip title="Save Changes">
                        <IconButton onClick={this.updateFinancialInfo}>
                          <Save />
                        </IconButton>
                      </Tooltip>
                    )}
                    {this.state.edit_financial_info && !this.state.busy && (
                      <Tooltip title="Cancel Changes">
                        <IconButton
                          onClick={() =>
                            this.setState({ edit_financial_info: false })
                          }
                        >
                          <Cancel />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>


                  Finances
                  {AnalysisTools.hasRecertificationPending(this.props.account) &&
                    (!this.props.account.finances.updated ||
                      this.props.account.finances.updated <
                      AnalysisTools.getRecertificationThreshold()) && (
                      <div className="indicator-badge">update required</div>
                    )}
                  <div className="indicator-badge-gray">
                    {(this.props.account.confirmations &&
                      this.props.account.confirmations
                        .finance_last_update_by === 'peoplejoy') ||
                      this.props.account.finance_info_last_update_by ===
                      'peoplejoy'
                      ? 'PeopleJoy '
                      : 'User '}
                    last confirmed Finance Information on{' '}
                    {moment(
                      (this.props.account.confirmations &&
                        this.props.account.confirmations.finance_employment) ||
                      this.props.account.finance_info_updated,
                      'X'
                    ).format('MM/DD/YYYY')}
                  </div>
                  <div className="line-break" />
                  <div className="full-width">
                    <div className="info-block">
                      {!this.state.edit_financial_info && (
                        <div>
                          <label>{grossIncomeText}</label>
                          {this.props.account.finances
                            ? `$${Formatter.moneyV2(this.props.account.finances.agi)}`
                            : 'Unknown'}
                        </div>
                      )}
                      {this.state.edit_financial_info && (
                        <TextField
                          disabled={this.state.busy}
                          type="number"
                          id="agi"
                          label={grossIncomeText}
                          value={this.state.financial_info.agi}
                          onChange={e =>
                            this.setState({
                              financial_info: {
                                ...this.state.financial_info,
                                agi: e.target.value
                              }
                            })
                          }
                          className="font-normal full-width"
                        />
                      )}
                    </div>
                    <div className="info-block">
                      {!this.state.edit_financial_info && (
                        <div>
                          <label>Tax Filing Status</label>
                          {printFilingStatus(this.props.account.finances?.status)}
                        </div>
                      )}
                      {this.state.edit_financial_info && (
                        <FormControl className="full-width font-normal">
                          <InputLabel
                            className="font-normal full-width"
                            htmlFor="status"
                          >
                            Tax Filing Status
                          </InputLabel>
                          <Select
                            className="font-normal full-width"
                            value={this.state.financial_info.status}
                            onChange={e =>
                              this.setState({
                                financial_info: {
                                  ...this.state.financial_info,
                                  status: e.target.value
                                }
                              })
                            }
                            inputProps={{
                              name: 'status',
                              id: 'status'
                            }}
                          >
                            <MenuItem value="single">Single or Head of Household</MenuItem>
                            <MenuItem value="married-jointly">
                              Married Filing Jointly
                            </MenuItem>
                            <MenuItem value="married-separately">
                              Married Filing Separately
                            </MenuItem>
                            <MenuItem value="household-head">
                              Married but Separated or cannot reasonably access spouse incom
                            </MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="info-block">
                          {!this.state.edit_financial_info && (
                            <div>
                              <label>Children Dependants</label>
                              {this.props.account.finances
                                ? this.props.account.finances.dependants
                                : 'Unknown'}
                            </div>
                          )}
                          {this.state.edit_financial_info && (
                            <TextField
                              disabled={this.state.busy}
                              type="number"
                              id="dependants"
                              label="Children Dependants"
                              value={this.state.financial_info.dependants}
                              onChange={e =>
                                this.setState({
                                  financial_info: {
                                    ...this.state.financial_info,
                                    dependants: e.target.value
                                  }
                                })
                              }
                              className="font-normal full-width"
                            />
                          )}
                        </div>
                        <div className="info-block">
                          {!this.state.edit_financial_info && (
                            <div>
                              <label>Other dependants:</label>
                              {this.props.account.finances &&
                                this.props.account.finances.roommates_number > 0
                                ? this.props.account.finances.roommates_number
                                : '0'}
                            </div>
                          )}
                          {this.state.edit_financial_info && (
                            <TextField
                              disabled={this.state.busy}
                              type="number"
                              id="roommates"
                              label="Other Dependants"
                              value={
                                this.state.financial_info.roommates_number ==
                                  null
                                  ? ''
                                  : this.state.financial_info.roommates_number
                              }
                              onChange={e =>
                                this.setState({
                                  financial_info: {
                                    ...this.state.financial_info,
                                    roommates_number: e.target.value
                                  }
                                })
                              }
                              className="font-normal full-width"
                            />
                          )}
                        </div>
                      </div>
                      {(this.state.financial_info.status == 'married-jointly' ||
                        this.state.financial_info.status ==
                        'married-separately') && (
                          <div className="col-12">
                            <div className="info-block">
                              {!this.state.edit_financial_info && (
                                <div>
                                  <label>Spouse has Federal Student Loan debt:</label>
                                  {this.props.account.finances &&
                                    this.props.account.finances.spouse_debt
                                    ? 'Yes'
                                    : 'No'}
                                </div>
                              )}
                              {this.state.edit_financial_info && (
                                <FormControl className="full-width font-normal">
                                  <InputLabel
                                    className="font-normal full-width"
                                    htmlFor="status"
                                  >
                                    Spouse has Federal Student Loan debt:
                                  </InputLabel>
                                  <Select
                                    disabled={this.state.busy}
                                    id="spouse_debt"
                                    value={
                                      this.state.financial_info.spouse_debt
                                        ? 'yes'
                                        : 'no'
                                    }
                                    onChange={e => {
                                      this.setState({
                                        financial_info: {
                                          ...this.state.financial_info,
                                          spouse_debt: e.target.value == 'yes'
                                        }
                                      });
                                    }}
                                    className="font-normal full-width"
                                  >
                                    <MenuItem value="yes">Yes</MenuItem>
                                    <MenuItem value="no">No</MenuItem>
                                  </Select>
                                </FormControl>
                              )}
                            </div>
                          </div>
                        )}
                      {this.state.financial_info.spouse_debt &&
                        (this.state.financial_info.status ==
                          'married-jointly' ||
                          this.state.financial_info.status ==
                          'married-separately') && (
                          <div className="col-12">
                            <div className="info-block">
                              {!this.state.edit_financial_info && (
                                <div>
                                  <label>Spouse's Student Loan debt</label>
                                  {this.props.account.finances
                                    ? `$${Formatter.money(
                                      this.props.account.finances.spouse
                                    )}`
                                    : 'Unknown'}
                                </div>
                              )}
                              {this.state.edit_financial_info && (
                                <TextField
                                  disabled={this.state.busy}
                                  type="number"
                                  id="spouse"
                                  label="Spouse's debt"
                                  value={this.state.financial_info.spouse}
                                  onChange={e => {
                                    if (
                                      Validators.isInteger(e.target.value) ||
                                      e.target.value == ''
                                    )
                                      this.setState({
                                        financial_info: {
                                          ...this.state.financial_info,
                                          spouse: e.target.value
                                        }
                                      });
                                  }}
                                  className="font-normal full-width"
                                />
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>

                </div>
              </Paper>
            </div>
            <EmploymentInfo
              account={this.props.account}
              id={this.props.id}
              onEmploymentSaved={this.updateEmploymentInfo}
            />

            {this.renderAccountInformation()}
          </div>

          {this.props.account.survey && this.props.account.employer.survey && (
            <div className="padding">
              <div className="line-break" />
              <h4>User Survey Answers</h4>
              <UserSurvey account={this.props.account} />
            </div>
          )}

          <MSDDetails
            account={this.props.account}
            onMyStudentDataUploaded={this.props.onMyStudentDataUploaded}
            onAnalysisUpdated={this.props.onAnalysisUpdated}
            onLoanUpdated={this.props.onLoanUpdated}
            msds={this.props.msds}
            getMsds={this.props.getMsds}
          />

          {this.props.account.loanType !== "private" &&
            <div style={{ marginBottom: '20px' }}>
              {this.renderBillingInformationForm()}
            </div>
          }
        </div>
      </div>
    );
  }
}

export default connect(null, {
  showError,
  showMessage,
  confirmAction
})(UserInfo);